import { compose } from 'redux'
import { connect } from 'react-redux'
import { show, hide } from 'redux-modal'
import { withHandlers, withProps, lifecycle } from 'recompose'
import isEqual from 'lodash/isEqual'
import withClientGeoLocation from 'components/common/hoc/withClientGeoLocation'
import withType from 'components/common/hoc/withType'
import withMakeThisMyLocation from 'components/common/hoc/withMakeThisMyLocation'
import withShowConfirmTireSizeModalPreconfigured from 'components/common/hoc/withShowConfirmTireSizeModalPreconfigured'
import StoreInformationWrapper from './StoreInformationWrapper'
import { BOT_STORE_INFORMATION_TYPE, STORE_ID_FOR_STAGE_REVIEWS } from '../../constants'
import { getStoreBaseURL, isProductionEnvironment } from '../../helpers'
import { getCurrentStoreNumber, getCurrentStoreIsE2EAppointment } from 'selectors/getCurrentStore'
import { setStoreDetailsInformation } from './actions'
import { processStoreNumFromURL } from 'helpers/storeLocator'
import { getHasActiveVehicleStatus, getActiveVehicle } from 'selectors'
import { getLocationPathname } from 'selectors/getPageLocation'
import {
  OPEN_TRUMPET_REVIEWS_TAB,
  SCHEDULE_APPOINTMENT,
  REQUEST_APPOINTMENT,
  TAB_YMME_NAME,
  YMME_NAME,
  HEADER_SOURCE
} from 'constant'
import { addVehicle } from 'actions/addVehicle'
import { navigateToSearchByVehicle } from 'actions/shopByVehicle'
import { showNewShopTiresModal } from '../../../NewShopTiresModal/actions'

const withFormattedLocationDetails = withProps(({
  storeInformation: {
    hasGoldAwardBadge,
    storeNum,
    appointmentEnable = false,
    storeAddress: {
      address1 = '',
      latitude = '',
      longitude = '',
      city = '',
      state = ''
    } = {},
    serviceName
  } = {}
} = {}) => ({
  storeNum,
  locationName: serviceName ? `${serviceName} in ${city}, ${state}` : `Big O Tires - ${city}, ${state}`,
  locationCoords: { latitude, longitude },
  locationAppointmentEnabled: appointmentEnable,
  hasGoldAwardBadge
}))

const mapStateToProps = (state, { storeNum }) => ({
  isCurrentStore: getCurrentStoreNumber(state) === storeNum,
  pathname: getLocationPathname(state) || '',
  hasActiveVehicle: getHasActiveVehicleStatus(state),
  activeVehicle: getActiveVehicle(state),
  isE2EAppointment: getCurrentStoreIsE2EAppointment(state)
})

const withStoreNumberByUrl = withProps(({ pathname, isE2EAppointment }) => ({
  storeNum: processStoreNumFromURL(getStoreBaseURL(pathname)),
  title: isE2EAppointment ? SCHEDULE_APPOINTMENT : REQUEST_APPOINTMENT
}))

const withSetMyLocationClickHandler = withHandlers({
  handleSetMyLocation: ({ storeNum, myLocationHandlers: { setMyLocation = () => {} } = {}}) => () =>
    setMyLocation(storeNum)
})

const withShopTiresClickHandler = withHandlers({
  handleShopTires: ({
    isCurrentStore,
    storeNum,
    hasActiveVehicle,
    activeVehicle,
    showNewShopTiresModal,
    ...props
  }) => async () => {
    const {
      navigateToSearchByVehicle,
      myLocationHandlers: { setMyLocation }
    } = props

    if (!isCurrentStore) {
      await setMyLocation(storeNum)
    }

    if (!hasActiveVehicle) {
      showNewShopTiresModal({
        tabName: TAB_YMME_NAME,
        ymmeName: YMME_NAME,
        withShowConfirmTireSizeModal: true,
        source: HEADER_SOURCE
      })
    } else {
      navigateToSearchByVehicle({ ...activeVehicle })
    }
  }
})

const withConfigureHandleShopTires = withProps(({
  handleShopTires,
  onClick,
  storeNum
}) => ({
  handleShopTires: onClick || handleShopTires,
  storeIdForTrustmary: isProductionEnvironment() ? storeNum : STORE_ID_FOR_STAGE_REVIEWS
}))

const setStoreDetailsAndRating = lifecycle({
  UNSAFE_componentWillMount() {
    const { storeInformation, setStoreDetailsInformation } = this.props
    setStoreDetailsInformation({ storeDetails: storeInformation })
  },
  componentDidUpdate({ storeInformation: prevStoreInformation }) {
    const { storeInformation, setStoreDetailsInformation } = this.props
    !isEqual(storeInformation, prevStoreInformation) && setStoreDetailsInformation({ storeDetails: storeInformation })
  }
})

const withOpenReviewsTabOnClick = withHandlers({
  openReviewsTabHandler: () => () => window.dispatchEvent(new CustomEvent(OPEN_TRUMPET_REVIEWS_TAB))
})

const mapDispatchToProps = {
  setStoreDetailsInformation,
  show,
  hide,
  addVehicle,
  navigateToSearchByVehicle,
  showNewShopTiresModal
}

export default compose(
  withType({ type: BOT_STORE_INFORMATION_TYPE }),
  withClientGeoLocation,
  withFormattedLocationDetails,
  connect(mapStateToProps, mapDispatchToProps),
  withStoreNumberByUrl,
  setStoreDetailsAndRating,
  withMakeThisMyLocation,
  withSetMyLocationClickHandler,
  withShowConfirmTireSizeModalPreconfigured,
  withShopTiresClickHandler,
  withConfigureHandleShopTires,
  withOpenReviewsTabOnClick
)(StoreInformationWrapper)
